// /src/components/modals/ImovelEditorModal/useEditorLogic.js
import { useState, useEffect, useCallback } from 'react';
import apiClient from '../../../api/apiClient';
import { ImovelExecutionEngine } from '../../../api/ImovelExecutionEngine';
import { ImovelUpdateEngine } from '../../../api/ImovelUpdateEngine';
import { toast } from 'react-toastify';

export const useEditorLogic = (imovelId, onClose, onUpdateSuccess) => {
    const [formData, setFormData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [removedImages, setRemovedImages] = useState([]);

    useEffect(() => {
        const fetchAtivo = async () => {
            try {
                setIsLoading(true);
                const { data } = await apiClient.get(`/api/imoveis/${imovelId}`);
                setFormData({
                    ...data,
                    isDestaque: data.isDestaque === true,
                    valorVenda: data.valores?.venda || 0,
                    valorAluguel: data.valores?.aluguel || 0,
                    valorCondominio: data.valores?.condominio || 0,
                    valorIptu: String(data.valores?.iptu || ''),
                    // ... mapeie outros campos conforme necessário
                });
            } catch (err) {
                toast.error("🚨 Falha na interceptação.");
                onClose();
            } finally { setIsLoading(false); }
        };
        if (imovelId) fetchAtivo();
    }, [imovelId, onClose]);

    const handleValueChange = useCallback((n, v) => setFormData(p => ({ ...p, [n]: v || 0 })), []);
    
    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(p => ({ ...p, [name]: type === 'number' ? Number(value || 0) : value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!ImovelExecutionEngine.validarFaseFinal(formData)) return;
        
        setIsSubmitting(true); setIsProcessing(true);
        try {
            // 🛡️ REFINARIA DE PAYLOAD (NÍVEL QUÂNTICO)
            const dataToUpdate = {
                ...formData,
                valorVenda: formData.valorVenda, // Força no primeiro nível para a Rota 18.0
                valorCondominio: formData.valorCondominio,
                valorIptu: formData.valorIptu
            };

            const payload = ImovelUpdateEngine.prepararPayloadEdicao(dataToUpdate, removedImages);
            const response = await ImovelUpdateEngine.executarUpdate(imovelId, payload);

            if (response.success) {
                toast.success(`🛡️ PLANO ATUALIZADO!`);
                if (onUpdateSuccess) onUpdateSuccess();
                onClose();
            }
        } catch (err) {
            toast.error("💥 Falha Crítica!");
        } finally {
            setIsProcessing(false); setIsSubmitting(false);
        }
    };

    return {
        formData, setFormData, isLoading, isSubmitting, isProcessing,
        handleChange, handleValueChange, handleSubmit, setRemovedImages
    };
};